import "core-js/modules/es.array.map";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
import { pick } from "../../utils";
import { STATUS_CANVAS_SELECTED } from "../../common/constants";
import withGGEditorContext from "../../common/context/GGEditorContext/withGGEditorContext";
import Panel from "./Panel";

var DetailPanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DetailPanel, _React$Component);

  function DetailPanel(props) {
    var _this;

    _classCallCheck(this, DetailPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DetailPanel).call(this, props));
    _this.state = {
      status: ''
    };

    _this.bindEvent();

    return _this;
  }

  _createClass(DetailPanel, [{
    key: "bindEvent",
    value: function bindEvent() {
      var _this2 = this;

      var onAfterAddPage = this.props.onAfterAddPage;
      onAfterAddPage(function (_ref) {
        var page = _ref.page;

        _this2.setState({
          status: STATUS_CANVAS_SELECTED
        });

        page.on('statuschange', function (_ref2) {
          var status = _ref2.status;

          _this2.setState({
            status: status
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var status = this.state.status;

      if (!status) {
        return null;
      }

      return React.createElement("div", pick(this.props, ['style', 'className']), React.Children.toArray(children).map(function (child) {
        return React.cloneElement(child, {
          status: status
        });
      }));
    }
  }]);

  return DetailPanel;
}(React.Component);

export var NodePanel = Panel.create('node');
export var EdgePanel = Panel.create('edge');
export var GroupPanel = Panel.create('group');
export var MultiPanel = Panel.create('multi');
export var CanvasPanel = Panel.create('canvas');
export default withGGEditorContext(DetailPanel);